import { useTranslation } from "react-i18next";

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage || "en";

  const Btn = ({ lng, label }) => (
    <button
      onClick={() => i18n.changeLanguage(lng)}
      className={`px-2 py-1 rounded-lg text-sm transition
        ${current === lng ? "bg-white/15 text-white" : "text-white/80 hover:bg-white/10"}`}
      aria-pressed={current === lng}
      aria-label={`Switch language to ${label}`}
      type="button"
    >
      {label}
    </button>
  );

  return (
    <div className="flex items-center gap-2" aria-label="Language">
      <Btn lng="en" label="EN" />
      {/* language code is "uk" but we label it UA for users */}
      <Btn lng="uk" label="UA" />
    </div>
  );
}